import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { injectIntl } from 'react-intl';
import useStyles from './header-jss';
import NotificationBlack from './HeaderIcon/ic_notifications_outline_black.svg';
import LogoutIcon from './HeaderIcon/ic_logout_black_20dp.svg';
import { bindActionCreators } from 'redux';
import { loginInfo, logout } from '../../redux/actions/authActions';
import { connect, useDispatch, useSelector } from 'react-redux';
import checkSession, { sessionCheck } from '../../utils/checkSession';
import moment from 'moment';
import cookies from 'react-cookies';
import {
  notificationListRequest,
  notificationReadRequest,
  notificationRemoveRequest,
} from '../../redux/actions/notification/notificationActions';
import timeFormAPI from '../../api/ui/timeFormAPI';
import btnIcons from '../../api/images/btnIcons';
import { playTransitionAction } from '../../redux/actions/uiActions';
import { useHistory } from 'react-router-dom';
import { HistoryAction } from '../../utils/history';
import config from '../../config/config';
import menuIcons from '../../api/images/menuIcons';
import './headerStyle.css';

// const elem = document.documentElement;

function Header(props) {
  // -- props -- //
  const { margin, /*history,*/ user, handleLogout } = props;

  const { classes, cx } = useStyles();
  // const notiListRef = useRef(null);
  const history = useHistory();

  // -- component const -- //
  const accessToken = cookies.load('token');

  // -- dispatch & selector -- //
  const dispatch = useDispatch();
  // const notiList = useSelector((state) => state.notificationReducer.list);
  // const resultCode = useSelector((state) => state.notificationReducer.resultCode);
  // const message = useSelector((state) => state.notificationReducer.message);

  // -- state -- //
  const [open] = useState(false);
  // const [turnDarker, setTurnDarker] = useState(false);
  // const [showTitle, setShowTitle] = useState(false);

  // 실시간 UTC
  const [realTime, setRealTime] = useState();
  const [realTimeKR, setRealTimeKR] = useState();

  // 노티 표시
  // const [showNoti, setShowNoti] = useState(false);

  // -- func -- //
  const handleClick = () => {
    handleLogout();
    cookies.remove('token', { path: '/' });
    history.push('/');
  };

  // const handleScroll = () => {
  //   const doc = document.documentElement;
  //   const scroll = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
  //   const newFlagDarker = scroll > 30;
  //   const newFlagTitle = scroll > 40;
  //   if (turnDarker !== newFlagDarker) {
  //     setTurnDarker(!turnDarker);
  //   }
  //   if (showTitle !== newFlagTitle) {
  //     setShowTitle(!showTitle);
  //   }
  // };

  // const showNotiList = () => {
  //   setShowNoti((prevState) => !prevState);
  // };

  // const handleClickRow = (row) => {
  //   dispatch(notificationReadRequest([row.notificationNo]));
  //   if (row.link) {
  //     history.push(`/${row.link}`);
  //   }
  // };

  // const handleDeleteRow = (row) => {
  //   dispatch(notificationRemoveRequest(row.notificationNo));
  // };
  //
  // useEffect(() => {
  //   window.addEventListener('scroll', handleScroll);
  //   return () => {
  //     window.removeEventListener('scroll', handleScroll);
  //   };
  // }, []);

  // useEffect(() => {
  //   const handleClickOutside = (e) => {
  //     // notificationList 영역 외부를 클릭하면 setShowNoti(false) 호출
  //     if (notiListRef.current && !notiListRef.current.contains(e.target)) {
  //       setShowNoti(false);
  //     }
  //   };
  //
  //   // 컴포넌트가 마운트되었을 때 이벤트 리스너를 추가
  //   document.addEventListener('click', handleClickOutside);
  //
  //   // 컴포넌트가 언마운트될 때 이벤트 리스너를 제거
  //   return () => {
  //     document.removeEventListener('click', handleClickOutside);
  //   };
  // }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setRealTime(moment.utc().format('YYYY-MM-DD A HH:mm:ss'));
      setRealTimeKR(
        moment.utc().add(9, 'hours').format('YYYY-MM-DD A HH:mm:ss'),
      );
    }, 500); // 매 0.5초마다 업데이트

    return () => clearInterval(interval); // 컴포넌트가 언마운트되면 타이머 해제
  }, []);

  useEffect(() => {
    // if (accessToken !== '' && accessToken !== undefined && accessToken !== null) {
    if (accessToken && accessToken !== '') {
      const getLoginInfo = bindActionCreators(loginInfo, dispatch);
      getLoginInfo(accessToken);
      checkSession();

      history.listen((_, action) => {
        if (action === HistoryAction.push) {
          const pageLoaded = bindActionCreators(playTransitionAction, dispatch);
          pageLoaded(false);
        }
      });
    }
  }, [accessToken]);

  useEffect(() => {
    if (user) {
      return;
    }
    if (accessToken && accessToken !== '') {
      const getLoginInfo = bindActionCreators(loginInfo, dispatch);
      getLoginInfo(accessToken);
      return;
    }
    const path = history.location.pathname;
    if (path.includes('twofa')) {
      history.replace('/', null);
    }
  }, [user]);

  // useEffect(() => {
  //   dispatch(notificationListRequest());
  // }, [dispatch, resultCode, message]);

  const curTime = new Date().getTime();
  const accessTime = Number(cookies?.load('time'));

  useEffect(() => {
    console.log(
      `세션 및 유저 정보 체크: (${
        user?.resultCode === 200 && !sessionCheck ? '정상' : '비정상'
      })`,
    );

    if (
      sessionCheck &&
      curTime - accessTime > config?.SESSION_EXPIRATION_TIME
    ) {
      cookies?.remove('token', { path: '/' });
      logout();
      window.location.assign('/');
    }

    // 30분마다 세션 상태를 체크하는 인터벌을 설정
    const interval = setInterval(() => {
      dispatch(loginInfo(accessToken));
    }, 1800000);

    // 컴포넌트가 언마운트될 때 인터벌을 해제하는 정리 함수
    return () => clearInterval(interval);
  }, [sessionCheck, user]);

  return (
    <AppBar
      className={cx(
        classes.appBar,
        classes.floatingBar,
        margin && classes.appBarShift,
        // turnDarker && classes.darker,
      )}
    >
      <Toolbar className="header" disableGutters={!open}>
        <div className="headerLeft">
          <img
            src={menuIcons.backofficeLogo}
            style={{ height: 24 }}
            className={'backofficeLogo'}
            alt="backofficeLogo"
          />

          {/* <div className='barDiv'/> */}

          <div>
            <p className="admin">
              {config.ENV !== 'prod' ? `Test Server\n` : `Prod Server\n`}
            </p>
            <p className="admin version">
              {/* {config.ENV !== 'prod' ? `ver ${config.VERSION}` : ''} */}
              {`ver ${config.VERSION}`}
            </p>
          </div>

          {/*<div className="barDiv" />*/}

          {/*<img*/}
          {/*  src={menuIcons.dfineryLogo}*/}
          {/*  style={{*/}
          {/*    height: 24,*/}
          {/*    cursor: 'pointer',*/}
          {/*  }}*/}
          {/*  className={'dfineryLogo'}*/}
          {/*  onClick={() => window.open('https://console.dfinery.io/', '_blank')}*/}
          {/*  alt="dfineryLogo"*/}
          {/*/>*/}
        </div>

        <div className="headerRight">
          <div className={'realtime'}>
            <p>{realTime + 'UTC'}</p>
            <p>{realTimeKR + 'KST'}</p>
          </div>

          <div className="barDiv" />

          {/* <img */}
          {/*   className="notificationIcon" */}
          {/*   src={NotificationBlack} */}
          {/*   alt="notiIcon" */}
          {/*   onClick={(e) => { */}
          {/*     e.stopPropagation(); */}
          {/*     showNotiList(); */}
          {/*   }} */}
          {/* /> */}

          {/* <div className="barDiv"/> */}

          <div>
            <p className="userName">
              {user?.name} 님({user?.departmentName})
            </p>

            <p className="userId">{user?.email}</p>
          </div>

          <div className="barDiv" />

          <img
            className="logoutIcon"
            src={LogoutIcon}
            alt="LogoutIcon"
            style={{ height: 32 }}
            onClick={handleClick}
          />

          {/* {showNoti ? ( */}
          {/*   <div className="notificationList" ref={notiListRef}> */}
          {/*     {notiList ? ( */}
          {/*       notiList.map((row) => ( */}
          {/*         <React.Fragment key={row.notificationNo}> */}
          {/*           <div */}
          {/*             // key={row.notificationNo} */}
          {/*             className={`notificationItem ${row.read ? 'read' : ''}`} */}
          {/*             onClick={() => handleClickRow(row)} */}
          {/*           > */}
          {/*             <p>{row.message}</p> */}
          {/*             <p>{timeFormAPI.changeDataLog(row.createAt)} UTC</p> */}
          {/*             <img */}
          {/*               className="deleteNoti" */}
          {/*               src={btnIcons.closeIcon} */}
          {/*               alt="제거" */}
          {/*               onClick={(e) => { */}
          {/*                 e.stopPropagation(); */}
          {/*                 handleDeleteRow(row); */}
          {/*               }} */}
          {/*             /> */}
          {/*           </div> */}
          {/*           <div className="sectionLine"/> */}
          {/*         </React.Fragment> */}
          {/*       )) */}
          {/*     ) : ( */}
          {/*       <React.Fragment> */}
          {/*         <div className="notificationItem"> */}
          {/*           <p */}
          {/*             style={{ */}
          {/*               textAlign: 'center', */}
          {/*               backgroundColor: '#CDCDD1', */}
          {/*               height: 30, */}
          {/*             }} */}
          {/*           > */}
          {/*             데이터 없음 */}
          {/*           </p> */}
          {/*         </div> */}
          {/*       </React.Fragment> */}
          {/*     )} */}
          {/*   </div> */}
          {/* ) : null} */}
        </div>
      </Toolbar>
    </AppBar>
  );
}

Header.propTypes = {
  toggleDrawerOpen: PropTypes.func.isRequired,
  avatar: PropTypes.string.isRequired,
  margin: PropTypes.bool.isRequired,
  isLogin: PropTypes.bool,
  dense: PropTypes.bool,
  mode: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  changeMode: PropTypes.func.isRequired,
  openGuide: PropTypes.func.isRequired,
  signOut: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  user: PropTypes.object,
  handleLogout: PropTypes.func.isRequired,
};

Header.defaultProps = {
  dense: false,
  isLogin: false,
};

const mapDispatchToProps = (dispatch) => ({
  handleLogout: bindActionCreators(logout, dispatch),
});

const mapStateToProps = (state) => ({
  state: state.authReducer,
  user: state.authReducer.user,
});

const HeaderMapped = connect(mapStateToProps, mapDispatchToProps)(Header);

export default injectIntl(HeaderMapped);
